class userRegister {

    static user = null;

    static setUser(user){
        userRegister.user = user;
        try {
            sessionStorage.setItem('user', JSON.stringify(user));
        }catch (e) {}
    }

    static getUser(){
        try {
            if(sessionStorage.getItem('user')){
                return JSON.parse(sessionStorage.getItem('user'));
            }else{
                return userRegister.user;
            }
        }catch (e) {
            return userRegister.user;
        }
    }

    static removeUser(){
        userRegister.user = null;
        try {
            sessionStorage.removeItem('user');
        }catch (e) {}
    }

    //SHORTENER
    static set(user){
        userRegister.setUser(user);
    }

    static get(){
        return userRegister.getUser();
    }

    static remove(){
        return userRegister.removeUser();
    }

}

export {userRegister}


// WEBPACK FOOTER //
// ./src/services/userRegister.js